import dayjs from "dayjs";
import { Item__Atividades } from "../../../../../../../../services/atividades/GET";
import { orderBy } from "lodash";
import { Item__EquipeCliente } from "../../../../../../../../services/Equipe/GET";



export type Executadas = {
    cod_atividade: number | null;
    descricao_atv_planejada: string,
    cod: number;
    area_executada: number;
    operador_nome: string | null;
    data_inicio: string | null;
    data_final: string;
    patrimonios: any[];
    insumos: any[];
    prazo: string;
}

type Planejadas = {
    cod_atividade: number;
    operacao: string;
    descricao: string;
    dias: number | string;
    data_inicio: string;
    data: string;
    referencia: number;
    conclusao: string;
    patrimonios: any[];
    insumos: any[];
};

export function obterExecucoes(atvs_planejadas: Item__Atividades[], atvs_executadas: Item__Atividades[], data_equipe_cliente: Item__EquipeCliente[]): { executadas: Executadas[], planejadas: Planejadas[] } {

    function obterNomeOperador(cod_func: number) {
        const equipe = (data_equipe_cliente??[]).find(item => item.cod_func === cod_func);
        return equipe?.usuario_nome || '';
    }

    //@ts-ignore
    const executadas: Executadas[] = (atvs_executadas ?? []).flatMap((atividade) => {
        
        return (atividade.andamentos ?? []).map((a: any) => ({
            cod_atividade: atividade?.cod_atividade ?? null,
            cod: a.cod,
            area_executada: Number(atividade.area_executada ?? 0),
            operador_nome: obterNomeOperador(a?.cod_usuario) ?? null,
            data_inicio: (atividade as any).data_inicio ?? null,
            data_final: (atividade as any).data_final ?? null,
            patrimonios: (a as any).patrimonios ?? [],
            insumos: (a as any).insumos ?? []
        }));
    });

    let incluir_descricao = (executadas??[]).map((item)=> {
        return {
            ...item,
            descricao_atv_planejada: atvs_planejadas.find(i=> i.cod === item.cod_atividade)?.descricao || ''
        }
    });

    let prazos_atvs = (incluir_descricao ?? []).map((item) => {

        let planejada = (atvs_planejadas ?? []).find(i => i.cod === item.cod_atividade);

        function obter() {
            if (item.data_final < planejada?.data_inicio && item.data_final < planejada?.data_final) {
                return 'Adiantado'
            }
            if (item.data_final >= planejada?.data_inicio && item.data_final <= planejada?.data_final) {
                return 'No prazo'
            }
            if (item.data_final > planejada?.data_final && item.data_final > planejada?.data_inicio) {
                return 'Atrasado'
            }
            else return ''
        }

        return {
            ...item,
            prazo: obter()
        }
    });    

    const planejadas: Planejadas[] = atvs_planejadas.map((atividade) => {
        const andamentos = atividade.andamentos ?? [];

        return {
            cod_atividade: atividade.cod,
            descricao: atividade.descricao,
            operacao: atividade.tipo_operacao || '',
            dias: atividade.dias,
            data_inicio: atividade.data_inicio,
            data: `${dayjs(atividade.data_inicio).format("DD/MM/YY")} - ${dayjs(atividade.data_final).format("DD/MM/YY")}`,
            conclusao:atividade?.data_conclusao ? dayjs(atividade?.data_conclusao).format("DD/MM/YY") : '-',
            referencia: atividade?.tipo_referencia,
            //@ts-ignore
            patrimonios: andamentos.flatMap(
                (andamento) => andamento.patrimonios || []
            ),
            //@ts-ignore
            insumos: andamentos.flatMap(
                (andamento) => andamento.insumos || []
            ),
        };
    });

    return { executadas: orderBy(prazos_atvs, ['data_inicio'], 'asc'), planejadas: orderBy(planejadas, ['data_inicio'], 'asc') };
}